import { saveLocalStorage } from 'configs/localStorage';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLazyGetEmailTrackingQuery } from 'store/services/emailTracking';
import useGetDomainTracking from 'store/services/helperHooks/useGetDomainTracking';
import { useLazyGetSystemNotificationsQuery } from 'store/services/notifications';
import { useLazyGetAdminDataQuery } from 'store/services/superAdmin/AdminUsers';
import { changeUserData } from 'store/slices/profile';
import Pagination from 'style-guide/Pagination';
import Table from 'style-guide/Table';
import Tabs, { TabPane } from 'style-guide/Tabs';
import Title from 'style-guide/Typography/Title';
import { paginate } from 'utils/helperFunctions';
import { COURSES_CONST } from '../Courses/columns';
import { getEmailTrackingColumns, getNotificationsColumns } from './column';

const SuperAdminEmailTracking = () => {
  const [page, setPage] = useState(1);
  const [notificationPage, setNotificationPage] = useState(1);
  const { data: domainData } = useGetDomainTracking();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [getEmailTracking, { data: emailsTracking }] = useLazyGetEmailTrackingQuery();
  const [getNotifications, { data: result }] = useLazyGetSystemNotificationsQuery();

  const [trigger] = useLazyGetAdminDataQuery();
  const setCourseUserData = async (item, path) => {
    await trigger({ id: item.id, table: COURSES_CONST.COURSES }).then((data) => {
      saveLocalStorage({
        user: data?.data,
      });
      dispatch(changeUserData({ isAuth: true, userData: data?.data }));
      navigate(path);
    });
  };

  useEffect(() => {
    getEmailTracking({ page, domainId: domainData?.id });
  }, [getEmailTracking, domainData, page]);

  useEffect(() => {
    getNotifications({
      ...paginate({ page: notificationPage - 1, limit: 10 }),
    });
  }, [getNotifications, notificationPage]);

  return (
    <div className='row'>
      <Tabs>
        <TabPane tab={<Title className='mb--16'>Email Notifications</Title>} key='email'>
          <div className='col-12'>
            <Table
              columns={getEmailTrackingColumns(setCourseUserData)}
              data={emailsTracking?.rows}
              rowKey={(row) => row.id}
            />
            <div className='mt--24'>
              <Pagination total={emailsTracking?.count} current={page} onChange={setPage} className='pagination' />
            </div>
          </div>
        </TabPane>
        <TabPane tab={<Title className='mb--16'>System Notifications</Title>} key='system'>
          <div className='col-12'>
            <Table columns={getNotificationsColumns()} data={result?.notifications} rowKey={(row) => row.id} />
            <div className='mt--24'>
              <Pagination
                total={result?.totalNotificationsCount}
                current={notificationPage}
                onChange={setNotificationPage}
                className='pagination'
              />
            </div>
          </div>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default SuperAdminEmailTracking;
